// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__15SoL","search":"Settings_search__kkZjo","filter":"Settings_filter__Nmfvj"};